<template>
  <div class="bg-white rounded box-shadow p-3">
    <b-modal id="award-book-modal" size="lg" title="Award Book Information" hide-footer>
      <div v-show="show" class="alert alert-danger alert-dismissible fade show" role="alert">
        <span v-for="(err, index) in validation_errors" :key="index">
          {{ err[0] }} <br/>
        </span>
      </div>
      <div class="modal-content bg-white rounded box-shadow">
        <form action="" enctype="multipart/form-data" files="true" role="form">
          <div class="form-row">
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label class="col-form-label col-form-label-sm" for="name">Name <span class="c-required">*</span></label>
              <input type="text" v-model="award_book.name" v-validate="{ required: true }" id="name" name="name" placeholder="Name" class="form-control form-control-sm"/>
              <div class="invalid-feedback">Name is required</div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label class="col-form-label col-form-label-sm" for="fathers_name">Father`s Name <span class="c-required">*</span></label>
              <input type="text" v-model="award_book.fathers_name" v-validate="{ required: true }" id="fathers_name" name="fathers_name" placeholder="Father` name" class="form-control form-control-sm"/>
              <div class="invalid-feedback">Father`s name is required</div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label class="col-form-label col-form-label-sm" for="book_no">Book No <span class="c-required">*</span></label>
              <input type="text" v-model="award_book.book_no" v-validate="{ required: true }" id="book_no" name="book_no" placeholder="Award book no." class="form-control form-control-sm"/>
              <div class="invalid-feedback">Book no. is required</div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label class="col-form-label col-form-label-sm" for="sub_book_no">Sub Book No.</label>
              <input type="text" v-model="award_book.sub_book_no" id="sub_book_no" name="sub_book_no" placeholder="Sub book no." class="form-control form-control-sm"/>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label class="col-form-label col-form-label-sm" for="total_land">Total Land</label>
              <input type="text" v-model="award_book.total_land"  v-validate="{ max: 15, regex: /^[0-9]*(?:\.[0-9]{0,5})?$/ }" id="total_land" name="total_land" placeholder="Total land" class="form-control form-control-sm"/>
              <div class="invalid-feedback">Total land is invalid</div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label class="col-form-label col-form-label-sm" for="amount">Amount</label>
              <input type="text" v-model="award_book.amount"  v-validate="{ regex: /^[0-9]*(?:\.[0-9]{0,2})?$/  }" id="amount" name="amount" placeholder="Amount" class="form-control form-control-sm"/>
              <div class="invalid-feedback">Amount is invalid</div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label class="col-form-label col-form-label-sm" for="award_book_type_id">Award Book Type <span class="c-required">*</span></label>
              <select v-model="award_book.award_book_type_id" v-validate="'required'" class="form-control form-control-sm" name="award_book_type_id" id="award_book_type_id">
                <option selected :value="''">Select a award book type</option>
                <option v-for="(award_book_type, index) in award_book_types" v-bind:value="award_book_type.id" :key="index">{{ award_book_type.award_book_type_desc }}</option>
              </select>
              <div class="invalid-feedback">Award book type is required</div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label class="col-form-label col-form-label-sm" for="award_book_e_type_id">Award Book E Type <span class="c-required">*</span></label>
              <select v-model="award_book.award_book_e_type_id" v-validate="'required'" class="form-control form-control-sm" name="award_book_e_type_id" id="award_book_e_type_id">
                <option selected :value="''">Select a award book e type</option>
                <option v-for="(award_book_e_type, index) in award_book_e_types" v-bind:value="award_book_e_type.id" :key="index">{{ award_book_e_type.award_book_e_type_desc }}</option>
              </select>
              <div class="invalid-feedback">Award book e type is required</div>
            </div>
          </div>
          <div class="form-row mt-2">
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label class="col-form-label col-form-label-sm" for="field_book_no">Field Book No</label>
              <input type="text" v-model="award_book.field_book_no" id="field_book_no" name="field_book_no" placeholder="Field book no." class="form-control form-control-sm"/>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label for="mouza_id">Mouza<span class="c-required">*</span></label>
              <select v-model="award_book.mouza_id" v-validate="'required'" @change="getPlotSchedule(award_book.mouza_id)" id="mouza_id" name="mouza_id" class="form-control form-control-sm">
                <option :value="''" selected>Select Mouza</option>
                <option v-for="(mouza, index) in mouzas" v-bind:value="mouza.id" :key="index">{{ mouza.id }} : {{ mouza.mouza_desc }}</option>
              </select>
              <div class="invalid-feedback">Please select valid mouza</div>
            </div>
          </div>
          <div class="form-row mt-2">
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label for="plot_schedule_id">Plot no.<span class="c-required">*</span></label>
              <select v-model="award_book.plot_schedule_id" v-validate="'required'"  id="plot_schedule_id" name="plot_schedule_id" class="form-control form-control-sm">
                <option :value="''" selected>Select Plot No.</option>
                <option v-for="(plot_schedule, index) in plot_schedules" v-bind:value="plot_schedule.id" :key="index">{{ plot_schedule.plot_no }}</option>
              </select>
              <div class="invalid-feedback">Please select valid plot no.</div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label class="col-form-label col-form-label-sm" for="remarks">Remarks</label>
              <textarea v-model="award_book.remarks" name="remarks" id="remarks" cols="30" rows="2" class="form-control form-control-sm"></textarea>
            </div>
          </div>
          <b-button v-if="!this.btn_edit" class="form-control-sm mr-2 mt-3" size="sm" variant="success" @click.prevent="save">Save</b-button>
          <b-button v-if="this.btn_edit" class="form-control-sm mr-2 mt-3" size="sm" variant="warning" @click.prevent="update">Update</b-button>
          <b-button class="form-control-sm mt-3"  size="sm" variant="danger" @click="$bvModal.hide('award-book-modal')">Cancel</b-button>
        </form>
      </div>
    </b-modal>
  </div>
</template>

<script>
import http from "@state/http";

export default {
  name: "awardBookModal",
  props: ["award_book", "btn_edit"],
  components: {},
  data() {
    return {
      award_book_types: [],
      award_book_e_types: [],
      mouzas: [],
      plot_schedules: [],
      /*data_plot_schedules: [],*/
      validation_errors: {},
      show: false
    };
  },

  mounted() {
    this.getCodes();
  },
  methods: {
    getCodes() {
      http.get("api/award-book/codes").then(response => {
        if (!response.error) {
          let data = response.data;
          this.award_book_types = data.award_book_types;
          this.award_book_e_types = data.award_book_e_types;
          this.mouzas = data.mouzas;
          this.plot_schedules = data.plot_schedules;
        }
      });
    },
    save() {
      this.$validator.validate().then(valid => {
        if (valid) {
          http
              .post("api/award-books", this.award_book )
              .then(response => {
                if (!response.error) {
                  if (response.data.permissionError) {
                    this.$bvToast.toast(response.data.permissionError, {
                      title: "Error",
                      autoHideDelay: 5000,
                      variant: "danger"
                    });
                  } else{
                    this.$bvToast.toast(response.data.message, {
                      title: "Success",
                      autoHideDelay: 5000,
                      variant: "success"
                    });
                  }

                  this.$bvModal.hide("award-book-modal");
                  this.$emit("search");
                }
              })
              .catch(error => {
                this.validation_errors = error.response.data.errors;
                this.show = true;
                this.hide();
              });
        }
      });
    },
    update() {
      this.$validator.validate().then(valid => {
        if (valid) {
          http
              .put("api/award-books/" + this.award_book.id, this.award_book )
              .then(response => {
                if (!response.error) {
                  if (response.data.permissionError) {
                    this.$bvToast.toast(response.data.permissionError, {
                      title: "Error",
                      autoHideDelay: 5000,
                      variant: "danger"
                    });
                  } else{
                    this.$bvToast.toast(response.data.message, {
                      title: "Success",
                      autoHideDelay: 5000,
                      variant: "success"
                    });
                  }
                  this.$bvModal.hide("award-book-modal");
                  this.$emit("search");
                }
              })
              .catch(error => {
                this.validation_errors = error.response.data.errors;
                this.show = true;
                this.hide();
              });
        }
      });
    },
    getPlotSchedule(mouza_id){
      this.plot_schedules = this.mouzas.find(
          mouza => mouza.id == mouza_id
      ).plot_schedules;
    },
    hide() {
      setTimeout(() => {
        this.show = false;
      }, 5000);
    },
  },
};
</script>
<style lang="scss">
.custom-select {
  color: #6c757d !important;
}
.c-required{
  color: red;
}
</style>
